import * as React from "react";
import GlobalStyles from "@mui/material/GlobalStyles/GlobalStyles";
import TopBar from "../../../components/TopBarV2";
import Container from "@mui/material/Container/Container";
import Typography from "@mui/material/Typography/Typography";
import Grid from "@mui/material/Grid/Grid";
import Stack from "@mui/material/Stack/Stack";
import MenuItem from "@mui/material/MenuItem/MenuItem";
import TextField from "@mui/material/TextField/TextField";
import InputAdornment from '@mui/material/InputAdornment';
import Chip from "@mui/material/Chip/Chip";
import { SelectChangeEvent } from "@mui/material/Select/Select";
import Button from "@mui/material/Button/Button";
import StepperProjectSetup from "../../../components/stepper-ps";
import Avatar from "@mui/material/Avatar/Avatar";
import { Autocomplete, circularProgressClasses, createFilterOptions, Fab, styled, Tooltip } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import firebase from "../../../firebase/firebase";
import { useFormik, FieldArray, getIn, FormikProvider } from "formik";
import { AuthUserContext } from "../../../providers/AuthProvider";
import ProjectSetup from "../../../validation/project-setup";
import Box from "@mui/material/Box/Box";
import { useNavigate, useLocation } from "react-router-dom";
import tooltipClasses from "@mui/material/Tooltip";
import { CheckCircle, Clear } from "@mui/icons-material";
import ScrollToTop from "../../../utils/scrollTop";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import "./projectdetails.css"
import { formatNumber } from "@formatjs/intl";
import preTags from "../../../utils/tags";
import { border, borderColor } from "@mui/system";


// const preTags = [
// 	"Feature Films",
// 	"Documentaries",
// 	"Animations",
// 	"Indie Shorts",
// 	"Anime",
// 	"TV Drama",
// 	"Comedy",
// 	"Horror",
// 	"Kdrama",
// 	"Cdrama",
// 	"Other",
// 	"All",
// ];

const geoTags = [
	"Africa",
	"America",
    "Asia",
	"Australia",
	"Brazil",
	"China",
	"Europe",
	"India",
	"Nigeria",
	"South Korea",
	"Spain",
	"U.K",
	"U.S.A",
	"All",
	"Other",
];
const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth",
    });
};
const HtmlTooltip = styled(({ className, ...props }) => (
	<Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: '#f5f5f9',
		color: 'rgba(0, 0, 0, 0.87)',
		maxWidth: 220,
		fontSize: theme.typography.pxToRem(12),
		border: '1px solid #dadde9',
	},
  }));
function StepOneProjectDetails() {
	
	const filter = createFilterOptions();
	const [projectImage, setProjectImage] = React.useState();
	const [projectReel, setProjectReel] = React.useState();
	const navigator = useNavigate();
	const location = useLocation();
	const [genre, setGenre] = React.useState([]);
	const [tags, setTags] = React.useState([]);
	const [loading, setLoading] = React.useState(false);
	const Input = styled("input")({
		display: "none",
	});
	const [profileImage, setProfileImage] = React.useState();
	const storageRef = firebase.storage().ref();
	const { user, profile } = React.useContext(AuthUserContext);
	const handleChange = (event: SelectChangeEvent<typeof genre>) => {
		const {
			target: { value },
		} = event;
		setGenre(
			// On autofill we get a stringified value.
			typeof value === "string" ? value.split(",") : value
		);
	};
	const handleKeyPress = (event) => {
		if(event.key === "."){
			event.preventDefault()
		}
	}

	const handleChangeTags = (event: SelectChangeEvent<typeof tags>) => {
		const {
			target: { value },
		} = event;
		setTags(
			// On autofill we get a stringified value.
			typeof value === "string" ? value.split(",") : value
		);
	};
	const formik = useFormik({
		initialValues: ProjectSetup.StepOneProjectDetailInitialValues,
		validationSchema: ProjectSetup.StepOneProjectDetailSchema,
		onSubmit: async (values) => {
			/*
			 *
			 * && location?.state?.spvName
			 * location?.state?.spvProject: profile?.organizationDetails?.type || ''
			 * */
			const projectRef = firebase.firestore().collection("projects");
			debugger
			const postObject = {
				spvProject:
					location?.state && location?.state?.spvProject
						? location?.state?.spvProject
						: undefined,
				uid: user.uid,
				creatorName: profile.name,
				organizationType:
					location?.state &&
					location?.state?.spvProject &&
					location?.state?.spvName
						? "SPV"
						: profile?.organizationDetails?.type,
				...values,
				mainCasts: values.mainCasts.map((d) => {
					return {
						avatar: d.documentPath,
						name: d.name,
						role: d.role,
						evidence: d.evidence.documentPath || ''
					};
				}),

				mediaFiles: {
					image: projectImage.path,
					reel: projectReel.path,
				},
				genre,
				tags,
				createdAt: firebase.firestore.FieldValue.serverTimestamp(),
			};
			// console.log("mainCasts");
			const addDocument = await projectRef.add(postObject);
			navigator(`/creator/projects/add/step/2/${addDocument.id}`);
			window.scrollTo(0, 0)
			console.log(`ProjectID: ${addDocument.id}`);
		},
	});

	const uploadFile = (type, formHelper, index, fileType) => {
		let file
		if(fileType==="evidence"){
			 file = formHelper.form.values[type][index].evidence.document;
		}
		else{
			file = formHelper.form.values[type][index].document;
		}
		const path = `projects/${type}/${user?.uid}/${file.name}`;
		const uploadTask = storageRef.child(path).put(file);
		uploadTask.on(
			"state_changed",
			(snapshot) => {
				// Observe state change events such as progress, pause, and resume
				// Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
				const progress =
					(snapshot.bytesTransferred / snapshot.totalBytes) * 100;
				console.log("Upload is " + progress + "% done");
				switch (snapshot.state) {
					case firebase.storage.TaskState.PAUSED: // or 'paused'
						console.log("Upload is paused");
						break;
					case firebase.storage.TaskState.RUNNING: // or 'running'
						console.log("Upload is running");
						break;
				}
			},
			(error) => {},
			() => {
				if (fileType==="evidence"){
					formHelper.replace(index, {
						...formHelper.form.values[type][index],
						evidence:{
							document: file,
							progress: 100,
							documentPath: path,
						}
					});
				}
				else{
					formHelper.replace(index, {
						...formHelper.form.values[type][index],
						progress: 100,
						documentPath: path,
					});
				}
			}
		);
	};
	return (
		<React.Fragment>
			<ScrollToTop/>
			<GlobalStyles
				styles={{ ul: { margin: 0, padding: 0, listStyle: "none" } }}
			/>
			{/* Hero unit */}
			{/*<TopBar showBar={true}/>*/}
			<StepperProjectSetup stepNumber={1} />
			<FormikProvider value={formik}>
				<Box component="form" onSubmit={formik.handleSubmit}>
					<Container maxWidth="md" sx={{ py: 5 }}>
						<Stack
							direction={"column"}
							justifyContent="flex-start"
							spacing={5}
							sx={{ width: "100%" }}>
							<Stack
								direction={{
									lg: "row",
									md: "row",
									sm: "column",
									xs: "column",
								}}
								justifyContent="flex-start"
								spacing={5}>
								{projectImage && projectImage.src ? (
									<>
										<Stack direction="column">
											<Box
												sx={{
													height: 310,
													width: 281,
													backgroundColor: "none",
													borderRadius: "14px",
												}}>
												<img
													src={projectImage.src}
													style={{
														height: 310,
														width: 281,
														borderRadius: "14px",
														position: "relative",
														top: 0,
														right: 0,
														opacity: 1,
														objectFit: "cover",
													}}
													alt=""
												/>
											</Box>
											<Button
												sx={{ py: 1.2 }}
												onClick={() => {
													setProjectImage({
														src: "",
														file: "",
													});
												}}>
												Remove picture
											</Button>

										</Stack>
									</>
								) : (
									<>
										<Box
											sx={{
												height: 310,
												width: 281,
												border: "2.5px dashed #204488",
												borderRadius: "14px",
											}}>
											{/*<label htmlFor="project-image">*/}
											<label htmlFor="project-image">
												<Stack
													direction="column"
													justifyContent="center"
													alignItems="center"
													spacing={1}
													sx={{ height: 310 }}>
													<Input
														accept="image/*"
														id="project-image"
														multiple={false}
														type="file"
														onChange={(e) => {
															const fileReader =
																new FileReader();
															fileReader.readAsDataURL(
																e.target
																	.files[0]
															);
															fileReader.addEventListener(
																"load",
																function () {
																	const result = this.result;
																	const path = `projects/mediaFiles/${user?.uid}/${e.target.files[0].name}`;
																	setProjectImage(
																		{
																			src: result,
																			file: e
																				.target
																				.files[0],
																			path: path
																		}
																	);

																	const uploadTask =
																		storageRef
																			.child(
																				path
																			)
																			.put(
																				e
																					.target
																					.files[0]
																			);
																	uploadTask.on(
																		"state_changed",
																		(
																			snapshot
																		) => {
																			// Observe state change events such as progress, pause, and resume
																			// Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
																			const progress =
																				(snapshot.bytesTransferred /
																					snapshot.totalBytes) *
																				100;

																			console.log(
																				"Upload is " +
																					progress +
																					"% done"
																			);
																			switch (
																				snapshot.state
																			) {
																				case firebase
																					.storage
																					.TaskState
																					.PAUSED: // or 'paused'
																					console.log(
																						"Upload is paused"
																					);
																					break;
																				case firebase
																					.storage
																					.TaskState
																					.RUNNING: // or 'running'
																					console.log(
																						"Upload is running"
																					);
																					break;
																			}
																		},
																		(
																			error
																		) => {},
																		() => {
																		}
																	);
																}
															);
														}}
													/>

													<Button
														component="span"
														color={"secondary"}
														startIcon={
															<img
																src="/assets/image-ps.png"
																style={{
																	width: 76,
																	height: 76,
																}}
																alt=""
															/>
														}></Button>

													<Typography
														variant={"caption"}>
														Upload project image
													</Typography>
												</Stack>
											</label>

											{/*</label>*/}
										</Box>
									</>
								)}

								{/* <Stack direction={'column'} justifyContent="center"            alignItems="center"
                       sx={{height:310, width: 281, border: '2px dashed #204488', borderRadius:'14px'}} spacing={3}>

                  <Input accept="image/*" id="project-image" multiple={false} type="file" onChange={(e) => {
                    const fileReader = new FileReader();
                    fileReader.readAsDataURL(e.target.files[0]);
                    fileReader.addEventListener("load", function () {

                      setProjectImage({
                        src: this.result,
                        file: e.target.files[0]
                      });


                    });
                  }} />
                  <Box>
                    <img src="/assets/image-ps.png" style={{width: 76, height:76}} alt=""/>
                    <Typography variant={'caption'}>
                      Upload project image
                    </Typography>
                  </Box>
                </Stack>*/}
								{projectReel && projectReel.src ? (
									<>
										<Stack direction="column">
											<Box
												sx={{
													height: 310,
													flex: 1,
													backgroundColor: "none",
													borderRadius: "14px",
												}}>
												<video
													autoPlay={false}
													controls
													src={projectReel.src}
													style={{
														height: 310,
														width: "100%",
														borderRadius: "14px",
														position: "relative",
														top: 0,
														right: 0,
														opacity: 1,
														objectFit: "cover",
													}}
													alt=""
												/>
											</Box>
											<Button
												sx={{ py: 1.2 }}
												onClick={() => {
													setProjectReel({
														src: "",
														file: "",
													});
												}}>
												Remove video
											</Button>

										</Stack>
									</>
								) : (
									<>
										<Box
											sx={{
												height: 310,
												flex: 1,
												border: "2.5px dashed #204488",
												borderRadius: "14px",
											}}>
											{/*<label htmlFor="project-image">*/}
											<label htmlFor="project-reel">
												<Stack
													direction="column"
													justifyContent="center"
													alignItems="center"
													spacing={1}
													sx={{ height: 310 }}>
													<Input
														accept="video/*"
														id="project-reel"
														multiple={false}
														type="file"
														onChange={(e) => {
															const fileReader =
																new FileReader();
															fileReader.readAsDataURL(
																e.target
																	.files[0]
															);

															fileReader.addEventListener(
																"load",
																function () {
																	const result = this.result;
																	const path = `projects/mediaFiles/${user?.uid}/${e.target.files[0].name}`;
																	setProjectReel(
																		{
																			src: result,
																			file: e
																				.target
																				.files[0],
																			path: path
																		}
																	);
																	const uploadTask =
																		storageRef
																			.child(
																				path
																			)
																			.put(
																				e
																					.target
																					.files[0]
																			);
																	uploadTask.on(
																		"state_changed",
																		(
																			snapshot
																		) => {
																			// Observe state change events such as progress, pause, and resume
																			// Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
																			const progress =
																				(snapshot.bytesTransferred /
																					snapshot.totalBytes) *
																				100;

																			console.log(
																				"Upload is " +
																					progress +
																					"% done"
																			);
																			switch (
																				snapshot.state
																			) {
																				case firebase
																					.storage
																					.TaskState
																					.PAUSED: // or 'paused'
																					console.log(
																						"Upload is paused"
																					);
																					break;
																				case firebase
																					.storage
																					.TaskState
																					.RUNNING: // or 'running'
																					console.log(
																						"Upload is running"
																					);
																					break;
																			}
																		},
																		(
																			error
																		) => {},
																		() => {
																			setProjectReel(
																				{
																					src: result,
																					file: e
																						.target
																						.files[0],
																					path,
																				}
																			);
																		}
																	);
																}
															);
														}}
													/>

													<Button
														component="span"
														color={"secondary"}
														startIcon={
															<img
																src="/assets/video-ps.png"
																style={{
																	width: 76,
																	height: 76,
																}}
																alt=""
															/>
														}></Button>

													<Typography
														variant={"caption"}>
														Upload Project Reel *
													</Typography>
												</Stack>
											</label>

											{/*</label>*/}
										</Box>
									</>
								)}

								{/*<Stack direction={'column'} justifyContent="center"            alignItems="center" sx={{height:310, flex:1, border: '2px dashed #204488', borderRadius:'14px'}} spacing={3}>
                  <img src="/assets/video-ps.png" style={{width: 76, height:76}} alt=""/>
                  <Typography variant={'caption'}>
                    Upload Project Reel *
                  </Typography>
                </Stack>*/}
							</Stack>
							<TextField
								fullWidth
								label={"Project Title*"}
								size={"medium"}
								value={formik.values.title}
								onChange={formik.handleChange}
								error={
									formik.touched.title &&
									Boolean(formik.errors.title)
								}
								helperText={
									formik.touched.title && formik.errors.title
								}
								name="title"
							/>
							<TextField
							multiline
								rows={4}
								fullWidth
								label={"Description*"}
								size={"medium"}
								value={formik.values.description}
								onChange={formik.handleChange}
								error={
									formik.touched.description &&
									Boolean(formik.errors.description)
								}
								helperText={
									formik.touched.description &&
									formik.errors.description
								}
								// InputProps={{maxLength:500}}
								name="description"
							/>
							{/* <Typography style={{marginLeft:"91%",marginTop:"-3px"}} sx={{color:"#818488"}}>{500-formik.values.description.length}/500</Typography> */}
							<TextField
								label={"Genre"}
								name={"genre"}
								value={formik.values.genre}
								onChange={formik.handleChange}
								error={
									formik.touched.genre &&
									Boolean(formik.errors.genre)
								}
								helperText={
									formik.touched.genre && formik.errors.genre
								}
								select
								sx={{ textAlign: "left" }}
								SelectProps={{
									multiple: true,
									value: genre,
									onChange: handleChange,
								}}>
								{preTags.map((t) => (
									<MenuItem value={t}>{t}</MenuItem>
								))}
							</TextField>
							{genre.length > 0 && (
								<Grid container  spacing={2} >
									{genre.length > 0 &&
										genre.map((d) => (
											<Chip  xs={2}
												label={d}
												variant="contained"
												sx={{
													backgroundColor: "#E3E8F0",
													marginLeft:"5px",
													marginRight:"5px",
													marginBottom:"10px"
												}}
												onDelete={() =>
													setGenre(
														genre.filter(
															(f) => f !== d
														)
													)
												}
											/>
										))}
								</Grid>
							)}

							<TextField
								name="rating"
								label={"Rating"}
								required
								value={formik.values.rating}
								onChange={formik.handleChange}
								error={
									formik.touched.rating &&
									Boolean(formik.errors.rating)
								}
								helperText={
									formik.touched.rating &&
									formik.errors.rating
								}
								sx={{ textAlign: "left" }}
								select>
								<MenuItem value={"G"}>G</MenuItem>
								<MenuItem value={"PG"}>PG</MenuItem>
								<MenuItem value={"PG-13"}>PG-13</MenuItem>
								<MenuItem value={"R"}>R</MenuItem>
								<MenuItem value={"NC-17"}>NC-17</MenuItem>
							</TextField>
							<TextField
								name={"releaseDate"}
								label={"Expected release date"}
								required={true}
								type={"date"}
								InputLabelProps={{
									shrink: true,
								}}
								inputProps={{
									max: "2072-01-01",
									min: "2022-01-01",
								}}
								value={formik.values.releaseDate}
								onChange={formik.handleChange}
								error={
									formik.touched.releaseDate &&
									Boolean(formik.errors.releaseDate)
								}
								helperText={
									formik.touched.releaseDate &&
									formik.errors.releaseDate
								}
							/>

							<TextField
								name={"investmentDeadline"}
								label={"Investment deadline"}
								required={true}
								type={"date"}
								inputProps={{
									max: "2072-01-01",
									min: "2022-01-01",
								}}
								InputLabelProps={{
									shrink: true,
								}}
								value={formik.values.investmentDeadline}
								onChange={formik.handleChange}
								error={
									formik.touched.investmentDeadline &&
									Boolean(formik.errors.investmentDeadline)
								}
								helperText={
									formik.touched.investmentDeadline &&
									formik.errors.investmentDeadline
								}
							/>
							<TextField
								name={"primaryFilmLocation"}
								required={true}
								label={"Primary film location"}
								select
								sx={{ textAlign: "left" }}
								value={formik.values.primaryFilmLocation}
								onChange={formik.handleChange}
								error={
									formik.touched.primaryFilmLocation &&
									Boolean(formik.errors.primaryFilmLocation)
								}
								helperText={
									formik.touched.primaryFilmLocation &&
									formik.errors.primaryFilmLocation
								}>
								{geoTags.map((t) => (
									<MenuItem value={t}>{t}</MenuItem>
								))}
							</TextField>

							<TextField
							
								name={"budget"}
								required={true}
								label={"Budget"}
								type="number"
								onKeyDown={handleKeyPress}
								value={formik.values.budget}
								onChange={formik.handleChange}
								error={
									formik.touched.budget &&
									Boolean(formik.errors.budget)
								}
								helperText={
									formik.touched.budget &&
									formik.errors.budget ? "budget must be of number type" : ""
								}
								variant="outlined"
								InputProps={{
										endAdornment: (
											<InputAdornment position="end">
												<AttachMoneyIcon/>
											</InputAdornment>
										),
										thousandSeparator:"." ,
           
										
									}}
							/>
							<TextField
								label={"Synopsis"}
								required={true}
								name="synopsis"
								multiline
								rows={4}
								value={formik.values.synopsis}
								onChange={formik.handleChange}
								error={
									formik.touched.synopsis &&
									Boolean(formik.errors.synopsis)
								}
								helperText={
									formik.touched.synopsis &&
									formik.errors.synopsis
								}
								
							/>
							{/* <Typography style={{marginLeft:"91%",marginTop:"-3px"}} sx={{color:"#818488"}}>{500-formik.values.synopsis.length}/500</Typography> */}
							<TextField
								label={"Plot"}
								required={true}
								name="plot"
								multiline
								rows={4}
								value={formik.values.plot}
								onChange={formik.handleChange}
								error={
									formik.touched.plot &&
									Boolean(formik.errors.plot)
								}
								helperText={
									formik.touched.plot && formik.errors.plot
								}
								
							/>
							{/* <Typography style={{marginLeft:"91%",marginTop:"-3px"}} sx={{color:"#818488"}}>{500-formik.values.plot.length}/500</Typography> */}

							<Typography
								variant={"h6"}
								sx={{ textAlign: "left" }}>
								Main Cast
							</Typography>
							<FieldArray
								name={"mainCasts"}
								render={(arrayHelpers) => {
									return (
										<>
											{arrayHelpers?.form.values.mainCasts.map(
												(cast, i) => (
													<>
														<Stack
															key={i}
															direction="row"
															justifyContent="flex-start"
															alignItems="center"
															spacing={5}>
															<label
																htmlFor={`mainCasts-${i}`}>
																<Avatar
																	alt={
																		"Tabain"
																	}
																	src={
																		arrayHelpers
																			.form
																			.values
																			.mainCasts[
																			i
																		]?.src
																			? arrayHelpers
																					.form
																					.values
																					.mainCasts[
																					i
																			  ]
																					?.src
																			: "/assets/default-avatar.png"
																	}
																	sx={{
																		width: 150,
																		height: 150,
																		cursor: "pointer",
																		objectFit:
																			"contain",
																	}}
																	imgProps={{
																		sx: {
																			objectFit:
																				"contain",
																		},
																	}}
																	component={
																		"span"
																	}
																/>
																<Input
																	accept="image/*"
																	id={`mainCasts-${i}`}
																	multiple={
																		false
																	}
																	type="file"
																	onChange={(
																		e
																	) => {
																		const fileReader =
																			new FileReader();
																		fileReader.readAsDataURL(
																			e
																				.target
																				.files[0]
																		);
																		fileReader.addEventListener(
																			"load",
																			async function () {
																				arrayHelpers.replace(
																					i,
																					{
																						...arrayHelpers
																							.form
																							.values
																							.mainCasts[
																							i
																						],
																						src: this
																							.result,
																						document:
																							e
																								.target
																								.files[0],

																					}
																				);

																				// setProfileImage({
																				//   src: this.result,
																				//   file: e.target.files[0],
																				//   size:  (e.target.files[0]?.size / 1024 / 1024).toFixed(2)
																				//
																				//
																				// });
																			}
																		);
																	}}
																/>
															</label>
															<Button
																disabled={arrayHelpers.form.values.mainCasts[i].progress<100}
																sx={{ py: 1.2 }}
																onClick={() => {
																	delete arrayHelpers
																		.form
																		.values
																		.mainCasts[
																		i
																	].document;
																	delete arrayHelpers
																		.form
																		.values
																		.mainCasts[
																		i
																	].src;
																	delete arrayHelpers
																		.form
																		.values
																		.mainCasts[
																		i
																	].progress;
																	delete arrayHelpers
																		.form
																		.values
																		.mainCasts[
																		i
																	].documentPath;
																	arrayHelpers.replace(
																		i,
																		{
																			...arrayHelpers
																				.form
																				.values
																				.mainCasts[
																				i
																			],
																		}
																	);

																}}>
																Remove picture
															</Button>

															<Button
																variant={
																	"outlined"
																}
																sx={{
																	py: 1.2,
																	px: 5,
																}}
																disabled={!arrayHelpers.form.values.mainCasts[i].src}
																onClick={() =>
																	{	arrayHelpers.replace(
																		i,
																		{
																			...arrayHelpers.form.values.mainCasts[i],
																			progress:0
																		}
																	);

																		uploadFile(
																			"mainCasts",
																			arrayHelpers,
																			i
																			)
																	}
																		}>
																Upload {arrayHelpers.form.values.mainCasts[i].progress===100 &&
																	 <CheckCircle style={{marginLeft: '15px'}}/>}
																	{arrayHelpers.form.values.mainCasts[i].progress<100 &&
																	<CircularProgress sx={{ml: 2}} size={20} color="primary"/>
																	}
															</Button>
														</Stack>
														<TextField
															label={"Name"}
															name={`mainCasts.${i}.name`}
															value={
																formik.values
																	.mainCasts[
																	i
																].name
															}
															onChange={
																formik.handleChange
															}
															error={

																getIn(formik.touched, `mainCasts.${i}.name`)
																&& getIn(formik.errors, `mainCasts.${i}.name`)

															}
															helperText={
																getIn(formik.touched, `mainCasts.${i}.name`)
																&& getIn(formik.errors, `mainCasts.${i}.name`) &&
																formik.errors
																	.mainCasts[
																	i
																].name
															}
														/>
														<TextField
															label={"Role"}
															sx={{
																textAlign:
																	"left",
															}}
															select
															name={`mainCasts.${i}.role`}
															value={
																formik.values
																	.mainCasts[
																	i
																].role
															}
															onChange={
																formik.handleChange
															}
															error={
																getIn(formik.touched, `mainCasts.${i}.role`)
																&& getIn(formik.errors, `mainCasts.${i}.role`)
															}
															helperText={
																getIn(formik.touched, `mainCasts.${i}.role`)
																&& getIn(formik.errors, `mainCasts.${i}.role`) &&
																formik.errors
																	.mainCasts[
																	i
																].role
															}>
															<MenuItem
																value={"Actor"}>
																Actor
															</MenuItem>
															<MenuItem
																value={"Actress"}>
																Actress
															</MenuItem>
															<MenuItem
																value={"Voice Over"}>
																Voice Over
															</MenuItem>
														</TextField>
											<Stack
												direction="row"
												justifyContent="flex-start"
												alignItems="center"
												spacing={5}
												>
												<HtmlTooltip arrow placement="bottom-start" title=
												{<>
												<Typography color="inherit">This step is required in order to confirm the cast participation in your project. The document will not be shared anywhere. You can use a contract for example.</Typography>
												</>}>
													<HelpOutlineIcon style={{ color: "#c0c0c0" }}/></HtmlTooltip>

												<label
													// htmlFor={`mainCasts-${i}`}
													style={{ width: "100%" }}
												>
													<Button
													variant={"outlined"}
													sx={{ py: 1.2, px: 5, borderRadius: 0 }}
													fullWidth
													component={"span"}
													startIcon={<UploadFileIcon />}
													>
													Upload evidence
													</Button>
													<Input
													accept="**/*"
													// id={`mainCasts-${i}`}
													multiple={false}
													type="file"
													onChange={(e) => {
														arrayHelpers.replace(i, {
														...arrayHelpers.form.values.mainCasts[i],
														evidence: {document:e.target.files[0], 
																	}
														});
													}}
													/>
												</label>
												<Button
													variant={"contained"}
													sx={{ py: 1.3, px: 5, borderRadius: 0 }}
													onClick={() => {
														let evidence=arrayHelpers.form.values.mainCasts[i].evidence
														let progress=0;
														evidence = {...evidence, progress}
														arrayHelpers.replace(
															i,
															{...arrayHelpers.form.values.mainCasts[i],
																evidence}
														);
													uploadFile("mainCasts", arrayHelpers, i, "evidence");
													}}
												>
													Upload
												</Button>
												</Stack>
												{formik.values.mainCasts[i].evidence.document !== undefined && (
														<Stack
															direction="row"
															justifyContent="flex-start"
															alignItems="center"
															spacing={2}
															sx={{
															borderBottom: "1px solid #204488",
															paddingY: 2,
															}}
														>
															<Stack
															direction="row"
															justifyContent="flex-start"
															alignItems="center"
															spacing={2}
															sx={{ flex: 1 }}
															>
															{formik.values.mainCasts[i].evidence.progress < 100 ? (
																<CircularProgress
																	variant="indeterminate"
																	disableShrink
																	sx={{
																	color: (theme) =>
																		theme.palette.mode === "light"
																		? "#b9b9bc"
																		: "#909093",
																	animationDuration: "550ms",
																	left: 0,
																	[`& .${circularProgressClasses.circle}`]:
																		{
																		strokeLinecap: "round",
																		},
																	}}
																	size={30}
																	thickness={4}
																	// {...props}
																/>
																) : (
																<>
																{formik.values.mainCasts[i].evidence.progress === 100 && <CheckCircle color={"primary"} style={{ height: 20, width: 20}}/>}
																{!formik.values.mainCasts[i].evidence.progress && 
																	<img
																	src="/assets/icons/file-upload.png"
																	style={{ height: 20, width: 20 }}
																	alt=""
																	/>
																}
																</>
																
																)}
															{/* <img
																src="/assets/icons/file-upload.png"
																style={{ height: 20, width: 20 }}
																alt=""
															/> */}

															<Typography color={"primary"}>
																{formik.values.mainCasts[i].evidence.document?.name}
															</Typography>
															</Stack>
															<Box
															sx={{
																paddingX: 2,
																borderRight: "1px solid #ccc",
															}}
															>
															<Box
																sx={{
																p: 1,
																background: "#204488",
																fontSize: "small",
																color: "#fff",
																}}
															>
																{(
																formik.values.mainCasts[i].evidence.document?.size /
																1024 /
																1024
																).toFixed(0) == 0
																? (
																	formik.values.mainCasts[i].evidence.document
																		?.size / 1024
																	).toFixed(0) + " KB"
																: (
																	formik.values.mainCasts[i].evidence.document
																		?.size /
																	1024 /
																	1024
																	).toFixed(0) + " MB"}
															</Box>
															</Box>
															<Fab
															color={"primary"}
															sx={{ boxShadow: "none" }}
															size={"small"}
															aria-label="delete"
															onClick={() => {
																delete arrayHelpers.form.values.mainCasts[i].evidence.document;
																delete arrayHelpers.form.values.mainCasts[i].evidence.progress;
																arrayHelpers.replace(i, {
																...arrayHelpers.form.values.mainCasts[i],
																});
															}}
															>
															<Clear />
															</Fab>
														</Stack>
														)}
												{
												arrayHelpers.form.values.mainCasts.length > 1 &&
												
												<Button  onClick={() => {
												
													arrayHelpers.remove(i);
												}}
												
												variant={"outlined"}
												sx={{
													borderRadius: 0,
													mt: 3,
													ml: 2,
													width: 180,
												}}
												startIcon={<RemoveIcon />}>
												Remove
											</Button>
											

													}
													</>
												)
											)}

											<Stack direction="row">
											<Button
										       
												onClick={() => {
													arrayHelpers.push({
														id: Math.random(),
														name: "",
														avatar: "",
														role: "",
														evidence:{},
													});
													// console.log('work experience add another clicked', arrayHelpers.form.values.mainCasts.length)

													
													
												}}

											
												variant={"outlined"}
												sx={{
													borderRadius: 0,
													mt: 3,
													
													width: 180,
												}}
												startIcon={<AddIcon />}>
												Add another
												
											</Button >
											

											</Stack>

										</>

									);


								}}
							/>
							<Stack direction="row">
							<Typography variant={"h5"}>Add tags</Typography>
							</Stack>
							<Stack
								direction={"column"}
								justifyContent="flex-start"
								spacing={5}
								sx={{ width: "100%" }}>
								{/* <TextField
									name={"tags"}
									label={"Tags"}
									select
									sx={{ textAlign: "left" }}
									SelectProps={{
										multiple: true,
										value: tags,
										onChange: handleChangeTags,
									}}
									value={formik.values.tags}
									onChange={formik.handleChange}
									error={
										formik.touched.tags &&
										Boolean(formik.errors.tags)
									}
									helperText={
										formik.touched.tags &&
										formik.errors.tags
									}>
									{preTags.map((t) => (
										<MenuItem value={t}>{t}</MenuItem>
									))}
								</TextField> */}
								<Autocomplete
										multiple
										required
										id="tags-filled"
										options={preTags.map((option) => option)}
										freeSolo
										onChange={(e, newValue)=>
													setTags(newValue)}
										renderTags={(value, getTagProps) =>
												tags.map((option, index) => (
														<Chip variant="contained"
														sx={{
															backgroundColor:"#E3E8F0",
															marginLeft:"5px",
															marginRight:"5px",
															marginBottom:"10px",
														}}
														onDelete={() =>
															setTags(
																tags.filter(
																	(f) => f !== option
																	)
													)
												}
												label={option} {...getTagProps({ index })} >
												</Chip>
												))
						
											}
										renderInput={(params) => (
										<TextField
											{...params}
											// variant={'standard'}
											label="Tags"
											placeholder="Add"
											sx={{
												
												transition:"0.1s linear",
												
												
											}}
										/>
										)}
									/>
								{/* {console.log(tags)}
								{tags.length > 0 && (
									<Grid container  spacing={2} >
										{tags.length > 0 &&
											tags.map((d) => (
												<Chip  xs={2}
													label={d}
													variant="contained"
													sx={{
														backgroundColor:"#E3E8F0",
														marginLeft:"5px",
														marginRight:"5px",
														marginBottom:"10px"
													}}
													onDelete={() =>
														setTags(
															tags.filter(
																(f) => f !== d
															)
														)
													}
												/>
											))}
									</Grid>
								)} */}
							</Stack>

							<Stack
								spacing={2}
								direction="row"
								sx={{
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
								}}>
								{/* <Button
									sx={{
										py: 1.2,
										px: 5,
										textDecoration: "underline",
									}}>
									Save as Draft
								</Button> */}

								<Button
									variant="contained"
									sx={{ py: 1.2, px: 5 }}
									type="submit"
									>
									Next
								</Button>
							</Stack>
						</Stack>
					</Container>
				</Box>
			</FormikProvider>
		</React.Fragment>
	);
}
export default StepOneProjectDetails;
